// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/mutation-uninstall.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App($app_id: uuid!) {
  apps_uninstall(app_id: $app_id) {
    ok
  }
}

`